import { useState } from 'react';
import QueueModal from '../components/QueueModal';
import StepBar from '../components/StepBar';
import { signInUrl, SITE_URL } from '../lib/supabase';
import { TRAILER_ID } from '../lib/trailer';

export default function SignedOut() {
  const [queueOpen, setQueueOpen] = useState(false);

  return (
    <main className="shell">
      <div className="card">
        <StepBar left="Signed out" right="See you on set" />
        <h1 className="d">
          You&rsquo;re signed
          <br />
          out.
        </h1>
        <p className="sub">The studio is still opening in batches. Take a look at where you stand.</p>
        <div className="rule" />
        <div className="actions">
          <button className="btn" type="button" onClick={() => setQueueOpen(true)}>
            Open the studio →
          </button>
          <a className="btn ghost" href={signInUrl(true)}>
            Sign back in
          </a>
          <a className="btn ghost" href={SITE_URL}>
            Back to frameon.us
          </a>
        </div>
      </div>

      {queueOpen ? (
        <QueueModal videoId={TRAILER_ID} exploreUrl={SITE_URL} onClose={() => setQueueOpen(false)} />
      ) : null}
    </main>
  );
}
